const styles = {
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
};

export default styles;